/* tslint:disable */
/* eslint-disable */
/**
 * MVC Games
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Season } from './Season';
import {
    SeasonFromJSON,
    SeasonFromJSONTyped,
    SeasonToJSON,
    SeasonToJSONTyped,
} from './Season';
import type { PagingOutput } from './PagingOutput';
import {
    PagingOutputFromJSON,
    PagingOutputFromJSONTyped,
    PagingOutputToJSON,
    PagingOutputToJSONTyped,
} from './PagingOutput';

/**
 * 
 * @export
 * @interface ListSeasonsOutputBody
 */
export interface ListSeasonsOutputBody {
    /**
     * A URL to the JSON Schema for this object.
     * @type {string}
     * @memberof ListSeasonsOutputBody
     */
    readonly $schema?: string;
    /**
     * Paging Output
     * @type {PagingOutput}
     * @memberof ListSeasonsOutputBody
     */
    pagingOutput: PagingOutput;
    /**
     * Seasons
     * @type {Array<Season>}
     * @memberof ListSeasonsOutputBody
     */
    seasons: Array<Season> | null;
}

/**
 * Check if a given object implements the ListSeasonsOutputBody interface.
 */
export function instanceOfListSeasonsOutputBody(value: object): value is ListSeasonsOutputBody {
    if (!('pagingOutput' in value) || value['pagingOutput'] === undefined) return false;
    if (!('seasons' in value) || value['seasons'] === undefined) return false;
    return true;
}

export function ListSeasonsOutputBodyFromJSON(json: any): ListSeasonsOutputBody {
    return ListSeasonsOutputBodyFromJSONTyped(json, false);
}

export function ListSeasonsOutputBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListSeasonsOutputBody {
    if (json == null) {
        return json;
    }
    return {
        
        '$schema': json['$schema'] == null ? undefined : json['$schema'],
        'pagingOutput': PagingOutputFromJSON(json['paging_output']),
        'seasons': (json['seasons'] == null ? null : (json['seasons'] as Array<any>).map(SeasonFromJSON)),
    };
}

export function ListSeasonsOutputBodyToJSON(json: any): ListSeasonsOutputBody {
    return ListSeasonsOutputBodyToJSONTyped(json, false);
}

export function ListSeasonsOutputBodyToJSONTyped(value?: Omit<ListSeasonsOutputBody, '$schema'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paging_output': PagingOutputToJSON(value['pagingOutput']),
        'seasons': (value['seasons'] == null ? null : (value['seasons'] as Array<any>).map(SeasonToJSON)),
    };
}

